module.exports = __webpack_public_path__ + "static/media/reporte2014.d2a82eab.png";